export enum Rule {
  RequiredRule,
}

export type RuleType = {
  type: Rule;
  message: string;
};
